module.exports = __webpack_public_path__ + "media/sofia/sofia-color_xl-3865a555.png";